/**
 * The Accordion function v1.0
 */
(function($) {
    $.fn.c24Accordion = function(settings) {
        const element = $(this);

        // Default settings
        $.c24Accordion = {
            defaults: {
                speed: 200,
                classes: {
                    header: 'c24Header',
                    content: 'c24Content',
                    open: 'c24Open',
                    parent: '',
                    fullWidthBorder: 'fullWidthBorder',
                },
                container: '.div24Main, .div24Content',
                scrollOnOpen: false,
                onOpen: false,
                onClose: false,
                allopen: false,
            },
        };

        if (element.data('c24Accordion-bound')) {
            return;
        }

        element.data('c24Accordion-bound', '1');

        const useChildren = element.data('usechildren');

        // Updates default settings with the user settings
        settings = $.extend({}, $.c24Accordion.defaults, settings);

        if (window.c24LpIsMobile) {
            settings.scrollOnOpen = true;
        }

        if (element.data('noscroll') ) {
            settings.scrollOnOpen = false;
        }

        const header = (settings.classes.parent ? '.' + settings.classes.parent + ' ' : '') + '> .' + settings.classes.header;
        const content = '.' + settings.classes.content;
        const open = '.' + settings.classes.open;

        if (element.hasClass('c24IgnoreAllOpen')) {
            settings.allopen = false;
        }

        // Initialize the class
        if (settings.allopen) {
            if (useChildren) {
                element.find(header).find(content).show();
            } else {
                element.find(header).next(content).show();
            }
            element.find(header).not(open).addClass(settings.classes.open);
        } else {
            if (useChildren) {
                element.find(header).find(content).hide();
                element.find(open).find(content).show();
            } else {
                element.find(header).next(content).hide();
                element.find(open).next(content).show();
            }
        }


        $('a', element).on('click', function(e) {
            e.stopPropagation();

            if ($(this).attr('href')?.startsWith('#')) {

                const linkGroup = $($(this).attr('href'), element).closest('li');
                const linkContent = linkGroup.find('div');
                const accordion = linkGroup.closest('.c24Accordion');

                if (!linkContent.is(':visible')) {
                    $('> li.' + settings.classes.open + ' > div', accordion).stop().slideUp(settings.speed);
                    $('> li', accordion).removeClass(settings.classes.open);
                    linkContent.stop().slideDown(settings.speed);
                    linkGroup.addClass(settings.classes.open);
                }
            }

        });


        element.on('click', header, function() {
            const headerObj = $(this);
            let el = headerObj.next(content);

            if (!el.length) {
                el = headerObj.find(content);
            }

            if (el.is(':visible')) {

                el.stop().slideUp(settings.speed);
                headerObj.removeClass(settings.classes.open);

                // is a onClose callback set?
                if (settings.onClose && typeof(settings.onClose) == 'function') {
                    settings.onClose();
                }
            } else {
                if (!settings.allopen) {
                    // CHECK HERE ACCOURDION INCEPTION !
                    element.find(content).stop().slideUp(settings.speed);
                    element.find(header).removeClass('c24Open');
                }

                el.stop().slideDown(settings.speed, function() {
                    let adjust = 0;
                    if (typeof window.c24AccordionAdjust != 'undefined') {
                        adjust = window.c24AccordionAdjust;
                    }

                    if (settings.scrollOnOpen || adjust ) {
                        $('html, body').animate({
                            scrollTop: Math.round(headerObj.offset().top - adjust),
                        }, 500);
                    }
                });
                headerObj.addClass(settings.classes.open);

                // is a onOpen callback set?
                if (settings.onOpen && typeof(settings.onOpen) == 'function') {
                    settings.onOpen();
                }
            }
        });

        if (element.hasClass('shadow') || element.hasClass('collapsed')) {
            $('> li > div', element).hide();
            $('> li.' + settings.classes.open + ' > div', element).show();

            element.on('click', '> li > h3', function() {
                const header = $(this);
                const group = $(header.parent());
                const accordion = $(group.parent());
                const content = $('> div', group);
                const lastChildInContent = content.children(':last-child');

                if (lastChildInContent.length && lastChildInContent.is('.c24ContentBox')) {
                    group.addClass(settings.classes.fullWidthBorder);
                }

                if (content.is(':visible')) {

                    if (group.hasClass('keepOpen')) {
                        return;
                    }
                    content.stop().slideUp(settings.speed, () => {
                        group.removeClass(settings.classes.open);
                    });
                    // is a onClose callback set?
                    if (settings.onClose && typeof(settings.onClose) == 'function') {
                        settings.onClose();
                    }
                } else {

                    group.removeClass('keepOpen');

                    $('> li.' + settings.classes.open + ' > div', accordion).stop().slideUp(settings.speed);
                    $('> li', accordion).removeClass(settings.classes.open);
                    content.stop().slideDown(settings.speed, function() {
                        let adjust = 0;
                        if (typeof window.c24AccordionAdjust != 'undefined') {
                            adjust = window.c24AccordionAdjust;
                        }
                        if (settings.scrollOnOpen || adjust ) {
                            $('html, body').animate({
                                scrollTop: Math.round(header.offset().top - adjust),
                            }, 500);
                        }
                    });
                    group.addClass(settings.classes.open);

                    // is a onOpen callback set?
                    if (settings.onOpen && typeof(settings.onOpen) == 'function') {
                        settings.onOpen();
                    }
                }
            });
        }
    };
})(window.jQuery);
